import axios from 'axios';
import { call } from 'redux-saga/effects';
import {
    GET_GENRE_FILTERS_ENDPOINT,
    GET_STATUS_FILTERS_ENDPOINT,
    GET_TYPE_FILTERS_ENDPOINT,
    GET_CINEMA_FILTERS_ENDPOINT,
    GET_CINEMA_LOCATIONS_ENDPOINT,
    GET_DISTRIBUTORS_ENDPOINT,
    GET_STUDIOS_ENDPOINT,
    GET_NEWS_CATEGORY_ENDPOINT,
    GET_SOON_IN_CINEMA_FILTERS_ENDPOINT,
    GET_BOXOFFICE_GENRE_FILTERS_ENDPOINT
} from '../config/apiEndpoints';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';


export function* getGenreFilters(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_GENRE_FILTERS_ENDPOINT, {}, { header });
}

export function* getStatusFilters(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_STATUS_FILTERS_ENDPOINT, {}, { header });
}

export function* getTypeFilters(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_TYPE_FILTERS_ENDPOINT, {}, { header });
}

export function* getCinemaFilters(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_CINEMA_FILTERS_ENDPOINT, {}, { header });
}

export function* getDistributorsFromAPI(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_DISTRIBUTORS_ENDPOINT, {}, { header });
}

export function* getStudiosFromAPI(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_STUDIOS_ENDPOINT, {}, { header });
}

export function* getCinemaLocations(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_CINEMA_LOCATIONS_ENDPOINT, header);
}

export function* getNewsCategory(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_NEWS_CATEGORY_ENDPOINT, header);
}

export function* getSoonInCinemaFilters(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_SOON_IN_CINEMA_FILTERS_ENDPOINT, header);
}

export function* getBoxOfficeGenreFilters(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_BOXOFFICE_GENRE_FILTERS_ENDPOINT, header );
}



// WEBPACK FOOTER //
// ./src/SHARED/api/filters.api.js